import { render, staticRenderFns } from "./StudentsByCoordinator.vue?vue&type=template&id=e67edc72&scoped=true&"
import script from "./StudentsByCoordinator.vue?vue&type=script&lang=js&"
export * from "./StudentsByCoordinator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e67edc72",
  null
  
)

export default component.exports